import React from "react";

const Loading = () => {
  return (
    <div className="loading">
      <h4>Rooms data loading...</h4>
      <div class="loadingio-spinner-ripple-3iio0w01mu4">
        <div class="ldio-x3dca39vl1m">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
